import type { AuditedCourseExpanded } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWRImmutable from "swr/immutable";

const useAuditedCourses = () => {
	const { isSignedIn } = useAuth();

	const {
		data: auditedCourses,
		mutate,
		...rest
	} = useSWRImmutable<AuditedCourseExpanded[]>(
		isSignedIn && `/courses/audited`,
		{
			errorRetryCount: 0,
		},
	);

	return {
		auditedCourses,
		isLoadingAuditedCourses: rest.isLoading,
		mutate,
		...rest,
	};
};

export default useAuditedCourses;
